export const STATUS_DRAFT = 'draft';
export const STATUS_ACTIVE = 'active';
export const STATUS_CANCELED = 'canceled';
export const STATUS_ENDED = 'ended';

export const STATUS_STYLES = {
    draft: {bg: 'bg-gray-200', text: 'text-muted', border: 'border-light', badge: 'badge-gray-500'},
    active: {bg: 'bg-light-green', text: 'text-success', border: 'border-success', badge: 'badge-success'},
    canceled: {bg: 'bg-light-red', text: 'text-danger', border: 'border-danger', badge: 'badge-danger'},
    ended: {bg: 'bg-light-orange', text: 'text-secondary', border: 'border-secondary', badge: 'badge-secondary'},
}
